// extracted by mini-css-extract-plugin
export var actionIcon = "_ur-0";